import type { TrackSearchOpenedSource } from '../../shared/contexts/SearchAnalyticsContext/types';

type SearchTrigger = 'header' | 'keyboard' | 'primary-nav';

const SOURCE_MAP: Record<
  'project' | 'workspaces' | 'fallback',
  Record<SearchTrigger, TrackSearchOpenedSource>
> = {
  project: {
    header: 'ProjectPageHeader',
    keyboard: 'ProjectPageKbShortcut',
    'primary-nav': 'ProjectPagePrimaryNav',
  },
  workspaces: {
    header: 'WorkspacesPageHeader',
    keyboard: 'WorkspacesPageKbShortcut',
    'primary-nav': 'WorkspacesPagePrimaryNav',
  },
  fallback: {
    header: 'Header',
    keyboard: 'Keyboard',
    'primary-nav': 'PrimaryNav',
  },
};

export function getSearchOpenedSource(
  pathname: string | null | undefined,
  trigger: SearchTrigger
): TrackSearchOpenedSource {
  if (!pathname) return SOURCE_MAP.fallback[trigger];

  if (pathname.startsWith('/project/')) {
    return SOURCE_MAP.project[trigger];
  }

  if (
    pathname === '/' ||
    pathname === '/workspaces' ||
    pathname.startsWith('/workspaces/')
  ) {
    return SOURCE_MAP.workspaces[trigger];
  }

  return SOURCE_MAP.fallback[trigger];
}
